import React, { createContext, useContext, useState, useCallback } from 'react';

const ScanContext = createContext();

export const useScanContext = () => {
  const context = useContext(ScanContext);
  if (!context) {
    throw new Error('useScanContext must be used within a ScanProvider');
  }
  return context;
};

export const ScanProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [lastUpdated, setLastUpdated] = useState(null);

  // Function to trigger refresh across all components
  const triggerRefresh = useCallback((source = 'unknown') => {
    console.log(`Triggering refresh from: ${source}`);
    setRefreshTrigger(prev => prev + 1);
    setLastUpdated(new Date().toISOString());
  }, []);

  // Function to trigger refresh specifically for scan data
  const refreshScanData = useCallback((scanId, source = 'unknown') => {
    console.log(`Refreshing scan data for scan ${scanId} from: ${source}`);
    triggerRefresh(`scan-${scanId}-${source}`);
  }, [triggerRefresh]);

  // Function to trigger refresh specifically for whitelist data
  const refreshWhitelistData = useCallback((source = 'unknown') => {
    console.log(`Refreshing whitelist data from: ${source}`);
    triggerRefresh(`whitelist-${source}`);
  }, [triggerRefresh]);

  const value = {
    refreshTrigger,
    lastUpdated,
    triggerRefresh,
    refreshScanData,
    refreshWhitelistData
  };

  return (
    <ScanContext.Provider value={value}>
      {children}
    </ScanContext.Provider>
  );
};
